import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';
import { FC } from 'react';
import styled, { css } from 'styled-components';

export const WeldDetailTabStyled = styled(Box).attrs({ pt: { sm: '400' } })`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey['300']};
    background-color: ${theme.colors.white};
  `}
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: auto;
  min-width: 110px;
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

export const HeadingStyled = styled(Box).attrs({ pb: { sm: '500' }, pt: { sm: '600' }, px: { sm: '500' } })`
  ${({ theme }) => css`
    background: ${theme.colors.grey[200]};
    border: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const FooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;
